import Exposure from './exposure.svg';
import Opacity from './opacity.svg';
import Time from './time.svg';

export default {
  Exposure,
  Opacity,
  Time,
};
